import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { BoxRoot } from './style';
import { BOX_CLASS_PREFIX } from './constants';
import { useBoxClassName } from './utils/useBoxClassName';
export var Box = function Box(_ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["className"]);

  var theme = useComponentTheme(BOX_CLASS_PREFIX);
  var classNameComponents = useBoxClassName(BOX_CLASS_PREFIX, className);
  return React.createElement(BoxRoot, Object.assign({}, restProps, {
    theme: theme,
    className: classNameComponents.Root
  }));
};